import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const events = [
  {
    id: 1,
    title: "Investing 101: Building Your First Portfolio",
    type: "Webinar",
    date: "Mar 12, 2026",
    time: "7:00 PM EST",
    host: "Sarah Mitchell, CFP",
    attendees: 234,
    icon: "Monitor",
    color: "#2D4A87",
  },
  {
    id: 2,
    title: "WIN Pitch Night: Women-Led Startups",
    type: "In-Person",
    date: "Mar 18, 2026",
    time: "6:30 PM EST",
    host: "WIN Network NYC",
    attendees: 89,
    icon: "MapPin",
    color: "#059669",
  },
  {
    id: 3,
    title: "Real Estate Investment Masterclass",
    type: "Masterclass",
    date: "Mar 22, 2026",
    time: "2:00 PM EST",
    host: "Dr. Keisha Brown",
    attendees: 156,
    icon: "BookOpen",
    color: "#D4A520",
  },
  {
    id: 4,
    title: "WIN Annual Wealth Retreat 2026",
    type: "Retreat",
    date: "Apr 5-7, 2026",
    time: "All Day",
    host: "WIN Leadership Team",
    attendees: 45,
    icon: "Sunrise",
    color: "#7C3AED",
  },
];

export default function UpcomingEvents() {
  const [rsvped, setRsvped] = useState({});

  const toggleRsvp = (id) => {
    setRsvped((prev) => ({ ...prev, [id]: !prev?.[id] }));
  };

  return (
    <section aria-label="Upcoming WIN Events">
      <div className="flex items-center justify-between mb-3 md:mb-4">
        <h2 className="font-heading font-semibold text-lg md:text-xl" style={{ color: "var(--color-foreground)" }}>
          Upcoming Events
        </h2>
        <button
          className="font-caption text-xs font-medium flex items-center gap-1"
          style={{ color: "var(--color-accent)" }}
        >
          View Calendar <Icon name="ChevronRight" size={14} color="var(--color-accent)" />
        </button>
      </div>
      {/* Horizontal scroll strip */}
      <div className="flex gap-3 overflow-x-auto pb-2" style={{ scrollbarWidth: "none" }}>
        {events?.map((event) => (
          <div
            key={event?.id}
            className="flex-shrink-0 rounded-xl p-3 md:p-4 flex flex-col justify-between"
            style={{
              width: "220px",
              minWidth: "220px",
              background: "var(--color-card)",
              border: "1px solid var(--color-border)",
            }}
          >
            <div>
              <div className="flex items-center gap-2 mb-2">
                <div
                  className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: `${event?.color}18` }}
                >
                  <Icon name={event?.icon} size={14} color={event?.color} />
                </div>
                <span
                  className="font-caption text-xs font-semibold px-2 py-0.5 rounded-full"
                  style={{ background: `${event?.color}18`, color: event?.color }}
                >
                  {event?.type}
                </span>
              </div>
              <h3
                className="font-caption font-semibold text-xs md:text-sm leading-snug mb-1 line-clamp-2"
                style={{ color: "var(--color-foreground)" }}
              >
                {event?.title}
              </h3>
              <div className="flex items-center gap-1 mb-0.5">
                <Icon name="Calendar" size={11} color="var(--color-muted-foreground)" />
                <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                  {event?.date}
                </span>
              </div>
              <div className="flex items-center gap-1 mb-0.5">
                <Icon name="Clock" size={11} color="var(--color-muted-foreground)" />
                <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                  {event?.time}
                </span>
              </div>
              <div className="flex items-center gap-1 mb-3">
                <Icon name="Users" size={11} color="var(--color-muted-foreground)" />
                <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                  {event?.attendees} attending
                </span>
              </div>
            </div>
            <Button
              variant={rsvped?.[event?.id] ? "secondary" : "default"}
              size="xs"
              fullWidth
              onClick={() => toggleRsvp(event?.id)}
            >
              {rsvped?.[event?.id] ? "RSVP'd ✓" : "RSVP"}
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
}